import { useEffect, useState } from 'react'

import type { ProfilePlan } from '../api/profile'
import { fetchSubscriptionPlans } from '../api/subscriptionPlans'
import {
  hasActiveSubscription,
  type PlanPurchaseAction,
  resolvePlanPurchaseAction,
} from '../lib/subscriptionPlanAction'

export function useSubscriptionPlanAction(
  profilePlan: ProfilePlan | undefined,
  enabled: boolean,
): PlanPurchaseAction | null {
  const [action, setAction] = useState<PlanPurchaseAction | null>(null)

  useEffect(() => {
    if (!enabled || !profilePlan) {
      setAction(null)
      return
    }

    if (!hasActiveSubscription(profilePlan)) {
      setAction('purchase')
      return
    }

    let cancelled = false
    void fetchSubscriptionPlans()
      .then((plans) => {
        if (!cancelled) {
          setAction(resolvePlanPurchaseAction(profilePlan, plans))
        }
      })
      .catch(() => {
        if (!cancelled) setAction(null)
      })

    return () => {
      cancelled = true
    }
  }, [enabled, profilePlan])

  return action
}
